(function () {
  var STICKY_SELECTOR = ".m-sticky-addtocart";
  var ANCHOR_SELECTOR = ".popup-video-section .jv-video-reel-anchor";
  var STICKY_GAP = 10;
  var rafId = null;

  function isStickyVisible(sticky) {
    if (!sticky) return false;

    var cs = window.getComputedStyle(sticky);
    if (cs.display === "none" || cs.visibility === "hidden") return false;

    var rect = sticky.getBoundingClientRect();
    if (rect.height < 1) return false;

    return rect.top < window.innerHeight - 4;
  }

  function updateThumbnails() {
    var sticky = document.querySelector(STICKY_SELECTOR);
    var anchors = document.querySelectorAll(ANCHOR_SELECTOR);
    if (!anchors.length) return;

    var visible = isStickyVisible(sticky);
    var bottomValue = "";

    if (visible) {
      bottomValue = sticky.getBoundingClientRect().height + STICKY_GAP + "px";
    }

    anchors.forEach(function (anchor) {
      if (visible) {
        anchor.classList.add("is-above-sticky-atc");
        anchor.style.setProperty("--jv-reel-sticky-bottom", bottomValue);
      } else {
        anchor.classList.remove("is-above-sticky-atc");
        anchor.style.removeProperty("--jv-reel-sticky-bottom");
      }
    });
  }

  function scheduleUpdate() {
    if (rafId) return;
    rafId = window.requestAnimationFrame(function () {
      rafId = null;
      updateThumbnails();
    });
  }

  function observeSticky(sticky) {
    if (!sticky || sticky.dataset.jvReelObserved === "true") return;
    sticky.dataset.jvReelObserved = "true";

    if (typeof ResizeObserver !== "undefined") {
      new ResizeObserver(scheduleUpdate).observe(sticky);
    }

    if (typeof MutationObserver !== "undefined") {
      new MutationObserver(scheduleUpdate).observe(sticky, {
        attributes: true,
        attributeFilter: ["style", "class"],
      });
    }
  }

  function bind() {
    window.addEventListener("scroll", scheduleUpdate, { passive: true });
    window.addEventListener("resize", scheduleUpdate);
    document.addEventListener("matchMobile", scheduleUpdate);
    document.addEventListener("unmatchMobile", scheduleUpdate);
    document.addEventListener("sticky-atc:update", scheduleUpdate);

    observeSticky(document.querySelector(STICKY_SELECTOR));

    scheduleUpdate();
    window.setTimeout(scheduleUpdate, 100);
    window.setTimeout(scheduleUpdate, 500);
    window.setTimeout(scheduleUpdate, 1500);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bind);
  } else {
    bind();
  }

  if (typeof customElements !== "undefined" && customElements.whenDefined) {
    customElements.whenDefined("sticky-atc").then(function () {
      observeSticky(document.querySelector(STICKY_SELECTOR));
      scheduleUpdate();
    });
  }
})();
